import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import LinearProgress from 'material-ui/LinearProgress';
import { getDocument } from '../../services/upload';
import './style.css'

class UpdateDocsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgUrl: null
    };
  }
  componentDidMount() {
    const path = this.props.router.location.pathname;
    const type = path.substr(path.lastIndexOf('/')+1);
    getDocument(type).then(
      response => {
        this.setState({
          imgUrl: response.data.data,
        });
    });
  }
  renderLoading = () => {
    if (!this.state.imgUrl) return (<LinearProgress color="#8BC027" mode="indeterminate" />);
  }
  render() {
    return (
      <div>
        {this.renderLoading()}
        <ImageContainer>
          <img alt="" id="doc-image" className="upload-doc-image" src={this.state.imgUrl} />
        </ImageContainer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    router: state.router,
    user: state.user,
    upload: state.upload
  };
};

export default connect(mapStateToProps)(UpdateDocsPage);

const ImageContainer = styled.div `
  margin: 80px auto 0 auto;
  width: 95%;
`;


// WEBPACK FOOTER //
// ./src/components/UpdateDocs/UpdateDocsPage.jsx